// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Publication, workflow etc. state of a module
 */
export interface ModuleStateOutput {
  workflowState: unknown;
  studentWorkflowState?: unknown;
  activeForCurrentUser?: unknown;
  editAccessRequested?: unknown;
}
